import { useEffect } from 'react'

import { getActions } from '../../global'
import useLang from '../../hooks/useLang'

// Error fallback for non-critical bundles: the app stays usable, so we only surface a
// notification instead of replacing the screen.
const ReloadNotification = () => {
  const lang = useLang()
  const { showNotification } = getActions()

  useEffect(() => {
    showNotification({ message: lang('Error.AnError') })
    // eslint-disable-next-line react-hooks-static-deps/exhaustive-deps
  }, [showNotification])

  return null
}

export default ReloadNotification
